import type {UpdateClientFormPayload} from "./update-client.schema";
import type {UpdateClientRequest} from "@project/sdk/sales";

export const updateClientMapper = {
  toSdk: (payload: UpdateClientFormPayload): UpdateClientRequest => ({
    company: {
      companyId: payload.companyId,
      companyName: payload.companyName,
      partyProfile: {
        address: {address: payload.address},
        country: payload.country,
        phone: {
          regionCode: payload.phonePrefix,
          nationalNumber: payload.phoneNumber,
        },
        websiteUrl: payload.websiteUrl,
      },
    },
    environments: payload.type,
    logoUrl: payload.logoUrl,
  }),
};
